import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'

import { Preloader } from '../../components/Preloader/Preloader'
import { SocialLinks } from '../../components/SocialLinks/SocialLinks'

import { ReactComponent as Chevron } from '../../assets/icons/chevron.svg'

import Backend from '../../api/backend'
import { BACKEND_IP, BACKEND_PORT, BACKEND_URL } from '../../utils/const'
import { telegramLink, twitterLink } from '../../utils/functions'

import './TokenView.scss'

const translate = str => {
  switch (str) {
    case 'body':
      return '身体'

    case 'face':
      return '脸'

    case 'hats':
      return '帽子'

    case 'shirt':
      return '衬衫'

    case 'tier':
      return '层'

    default:
      return str
  }
}

export const TokenView = () => {
  const { id } = useParams()
  const history = useHistory()
  const [info, setInfo] = useState(null)

  useEffect(() => {
    let isMount = true

    new Backend(BACKEND_URL, BACKEND_PORT).getTokenInfo(id)
      .then(res => {
        if (isMount) setInfo({ ...res.imageInfo, owner: res.owner})
      })
      .catch(e => {
        console.log(e)
        if (isMount) setInfo({})
      })

    return () => isMount = false
  }, [id, setInfo])

  const infoLink = (link, label) => (
    <a
      href={ link }
      className="info-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      { label }
    </a>
  )

  const attrs = []
  if (info && info.traits)
    for (const key in info.traits) {
      if (Object.hasOwnProperty.call(info.traits, key)) {
        attrs.push(
          <div key={ key } className="prop-item">
            <span className="title">
              { translate(key) }
            </span>
            <span className="subtitle">
              { info.traits[key] }
            </span>
          </div>
        )
      }
    }

  return (
    <div className="token-view">
      <div className="row">
        <button
          className="back-button"
          onClick={ () => history.replace({ pathname : '/gallery' }) }
        >
          <Chevron />
          <span>
            返回
          </span>
        </button>
      </div>
      {
        info
        ? (
          <div className="row">
            <div className="image-container">
              <img
                src={`${ BACKEND_IP }/img/${ id }.jpg`}
                alt="cat"
              />
              <p className="share">
                不知道哪个酷猫是你最喜欢的？ 向你的朋友请教!
              </p>
              <div className="links-row">
                <SocialLinks
                  className="icon-link"
                  twlink={twitterLink( id )}
                  tgLink={telegramLink( id )}
                />
              </div>
            </div>
            <div className="info-container">
              <h1>
                TRON COOLCAT #{ id }
              </h1>
              <p>
                所属: {
                  info.owner && info.owner !== '-'
                  ? infoLink(
                      `https://tronscan.io/#/address/${ info.owner }`,
                      info.owner.substr(0, 7)
                    )
                  : '未知'
                }
              </p>
              <h1>
                属性
              </h1>
              <p>
                稀有等级 {
                  info.traits && info.traits.special
                  ? `#${ info.rank }`
                  : infoLink(
                    `https://rarity.tools/cool-cats-nft/view/${ id }`,
                    `#${ info.rank }`
                  )
                }
              </p>
              <div className="prop-list">
                { attrs }
              </div>
            </div>
          </div>
        )
        : <Preloader />
      }
    </div>
  )
}